import '../../utils/MuiClassNameSetup';

import React, { FC, useState } from 'react';
import { combineReducers } from 'redux';
import { mdModule } from '@rakutenfrance/breakpoint';
import { renderReact } from '../../fragmentHelper/renderReactCustom';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { colorPalette, Drawer } from '@rakutenfrance/mui';
import { load } from 'hypernova';
import { hydrateRoot } from 'react-dom/client';

declare global {
  interface Window {
    hypernovaLoiLemaireLazyInit: any;
  }
}

const StyledLink = styled('a')({
  textDecoration: 'underline',
  color: colorPalette.gray700,
  fontWeight: 400,
});

const mdReducer = mdModule.reducer;

const LoiLemaire: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const reducer = combineReducers({
    md: mdReducer,
  });

  return (
    <ReduxApolloFragmentWrapperChildren initialApolloState={{}} initialReduxState={{}} reducers={reducer}>
      <Stack>
        <Drawer
          open={open}
          onClose={(): void => {
            setOpen(false);
          }}
          showHeader
          title="Garanties applicables"
          PaperProps={{
            sx: {
              maxHeight: '45vh',
            },
          }}
          content={
            <Typography
              component="p"
              sx={{
                padding: '16px',
                color: colorPalette.gray700,
                fontWeight: 400,
                fontSize: '14px',
              }}
            >
              Tous les achats éligibles à la{' '}
              <StyledLink
                href="https://help.fr.shopping.rakuten.net/hc/fr/articles/10324490666002-A-quoi-correspondent-les-frais-de-protection-acheteur-pr%C3%A9lev%C3%A9s-lors-de-mon-achat"
                target="_blank"
              >
                protection acheteurs
              </StyledLink>{' '}
              bénéficient de l’avantage “Satisfait ou remboursé”. Toutefois, le droit de rétractation au sens de l’article L.221-18 et la
              garantie légale de conformité visée aux articles L.217-3 et suivants du Code de la consommation ne sont pas applicables pour
              cet achat réalisé auprès d’un vendeur particulier. La garantie légale des vices cachés visée aux articles 1641 à 1649 du Code
              civil reste applicable. En savoir plus sur les dispositions légales relatives au{' '}
              <StyledLink
                href="https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006070721/LEGISCTA000032006712/#LEGISCTA000032006712"
                target="_blank"
              >
                droit des obligations
              </StyledLink>{' '}
              et de la{' '}
              <StyledLink href="https://www.legifrance.gouv.fr/codes/id/LEGISCTA000032009929" target="_blank">
                responsabilité civile
              </StyledLink>
              .
            </Typography>
          }
        />
        <Stack
          component="div"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          onClick={(): void => {
            setOpen(true);
          }}
        >
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: colorPalette.gray700,
            }}
          >
            En savoir plus sur les garanties applicables
          </Typography>
          <ChevronRightIcon
            sx={{
              color: colorPalette.gray700,
              height: 24,
              width: 24,
            }}
          />
        </Stack>
      </Stack>
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const renderFunction = renderReact('LoiLemaire', LoiLemaire);

if (typeof window !== 'undefined') {
  window.hypernovaLoiLemaireLazyInit = (): void => {
    const payloads: any[] = load('LoiLemaire');
    if (!payloads) return;

    payloads.forEach((payload) => {
      const { node, data } = payload;

      if (!node) return;

      if (node._reactRoot) {
        try {
          node._reactRoot.unmount();
        } catch (err) {
          console.warn('Failed to unmount existing root', err);
        }
      }

      const element = React.createElement(LoiLemaire, data);
      node._reactRoot = hydrateRoot(node, element);
    });
  };
}

export const serverCanCache = true;
